<script setup lang="ts">
import { useAuthProcessStore } from '#imports';

const service = useAuthProcessStore();

const form = ref();

const successMessage = ref();

async function onSubmit() {
  form.value.clear();
  successMessage.value = await service.passwordRecovery(errors => setBackendErrors(form.value, errors));
}
</script>

<template>
  <UAlert
    v-if="successMessage"
    icon="i-heroicons-check-circle"
    :title="successMessage"
  />
  <UForm
    v-else
    ref="form"
    :schema="service.passwordRecoverySchema()"
    :state="service.data"
    :validate-on="['submit']"
    class="space-y-4"
    @submit="onSubmit"
  >
    <UCard>
      <template #header>
        <slot name="header" />
      </template>

      <UFormGroup :label="$t('auth.email')" name="email">
        <UInput v-model="service.data.email" icon="i-heroicons-envelope" :placeholder="$t('auth.emailPlaceholder')" />
      </UFormGroup>

      <template #footer>
        <div class="flex items-center">
          <UButton type="submit" :loading="service.loading">
            {{ $t('auth.submitPasswordRecovery') }}
          </UButton>
          <UButton :to="useUrlWithRedirect('/auth/login')" class="ml-2" variant="link" :disabled="service.loading">
            {{ $t('auth.linkToLogin') }}
          </UButton>
          <UButton :to="useUrlWithRedirect('/auth/register')" class="ml-1" variant="link" :disabled="service.loading">
            {{ $t('auth.linkToRegister') }}
          </UButton>
        </div>
      </template>
    </UCard>
  </UForm>
</template>
